import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Spinner from "../components/spinner.react";
import InputWithError from "../components/inputWithError.react";
import Select from "react-select";
import Modal from "../components/modal.react";
import Table from "./table.react";

export default class PagesLists extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getPagesLists();
  }

  getPagesLists = () => {
    const {
      actions,
      notificationSystem,
      pagesLists: { pagesLists: { meta: pagesListsMeta, sort: pagesListsSort } }
    } = this.props;
    actions.clearForm("pagesLists", "createPagesList");
    actions
      .getPagesLists(pagesListsMeta, pagesListsSort)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  openAddPagesListModal = () => {
    const { actions } = this.props;
    actions.setIsAddPagesListModalVisible(true);
  };

  closeAddPagesListModal = () => {
    const { actions } = this.props;
    actions.setIsAddPagesListModalVisible(false);
  };

  createPagesList = () => {
    const {
      actions,
      pagesLists: { forms: { createPagesList: { fields } } },
      notificationSystem
    } = this.props;
    actions.createPagesList(fields).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        this.getPagesLists();
      }
    });
    actions.setIsAddPagesListModalVisible(false);
  };

  render() {
    const {
      actions,
      pagesLists: { forms },
      msg: { pagesLists: msg }
    } = this.props;

    const createPagesListFormProps = {
      feature: "pagesLists",
      actions: actions,
      form: forms.createPagesList,
      formName: "createPagesList",
      msg: msg.forms.createPagesList,
      validateFormField: actions.validateFormFieldPagesLists
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">Listy stron</h2>
          <div className="col-xs-4">
            <button className="info" onClick={this.openAddPagesListModal}>
              dodaj listę
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Wszystkie listy stron</div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
              </div>
            </div>
          </div>
        </div>
        {forms.createPagesList.isAddModalVisible && (
          <Modal
            closeModalAction={this.closeAddPagesListModal}
            enterAction={this.createPagesList}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Utwórz nowy wpis:</h3>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Nazwa"
                  field="name"
                  {...createPagesListFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Slug"
                  field="slug"
                  {...createPagesListFormProps}
                />
              </div>
              <button className="error" onTouchTap={this.createPagesList}>
                Tak
              </button>
              <button className="info" onTouchTap={this.closeAddPagesListModal}>
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pagesLists/pagesLists.react.js